<template>
  <div id="shortcut">
    <div class="w">
      <div class="login-status logined">
        <!-- <span class="zyz_dw">
          <img src="~@/assets/images/图层 854.png" class="dw_t1" />
          <img src="~@/assets/images/htmal5icon14.png" class="dw_t2" />
          上海</span
        > -->
      </div>
      <!--
      <ul class="links">
        <li>
          <div class="dt">
            <a href='' class="ahover">小卖部</a>
          </div>
        </li>
        <li class="spacer"></li>
        <li>
          <div class="dt">
            <a href=''>小讲堂</a>
          </div>
        </li>
        <li class="spacer"></li>
        <li>
          <div class="dt">
            <a href=''>小喇叭</a>
          </div>
        </li>
        <li class="spacer"></li>
        <li>
          <div class="dt">
            <a href=''>找一找</a>
          </div>
        </li>
      </ul> -->

      <ul class="links links2">
        <li v-if="isPublic == '1'">
          <div class="dt">
            <span>
              <router-link :to="`/member/my-profile`">{{ user.nickname }} </router-link>
              <div class="spacer"></div>
            </span>
          </div>
        </li>
        <li v-else>
          <div class="dt">
            <span>
              <router-link v-if="!user.nickname && !fromJRC" :to="'/login' + MixinForward">登录</router-link>
              <router-link v-else :to="`/member/my-profile`">{{ user.nickname }} </router-link>
              <router-link v-if="!user.nickname && !fromJRC" :to="'/register' + MixinForward">& 注册 </router-link>
              <a v-show="user.nickname && !loginNow && !fromJRC" href="javascript:" @click="handleLogout">& 退出</a>
              <div class="spacer"></div>
            </span>
          </div>
        </li>
        <li class="spacer" v-if="!fromJRC"></li>

        <li v-show="user.purchase_type == '2'">
          <div class="dt">
            <el-dropdown >
              <span class="el-dropdown-link" style="cursor: pointer;"> 企业信息<i class="el-icon-arrow-down el-icon--right"></i> </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item  v-for="(item,index) in user.department_detail_dtos" :key="index">
                  <div style="line-height: 24px;">{{ item.enterprise_name }}</div>
                  <div style="line-height: 24px;" :style="{borderBottom:index == user.department_detail_dtos.length -1 ? 'none' :'1px solid #ccc' }">{{ item.department_name }}</div>
                </el-dropdown-item>
                
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </li>
        <li class="spacer" v-show="user.purchase_type == '2'"></li>
        <li>
          <div class="dt">
            <router-link :to="'/member'">个人中心 </router-link>
            <!-- <a href="/member">个人中心</a> -->
          </div>
        </li>
        <li class="spacer"></li>
        <li>
          <div class="dt">
            <!-- <a href="/member/my-order">我的订单</a> -->
            <router-link :to="'/member/my-order'">我的订单 </router-link>
          </div>
        </li>
        <li class="spacer"></li>
        <li>
          <div class="dt">
            <!-- <a href="">客服服务</a> -->
            <a style="cursor: pointer;" @click="showPhone">客服电话</a>
          </div>
        </li>
        <li class="spacer"></li>
        <li>
          <div class="dt">
            <!-- <router-link  :to=" user.have_shop? MixinDomain.seller : '/shop/apply'">{{ user.have_shop ? '我的店铺' : '商家入驻' }} {{MixinDomain.seller}}</router-link> -->
            <!-- <a :href="user.have_shop ? MixinDomain.seller : '/shop/apply/'">{{ user.have_shop ? '我的店铺' : '商家入驻' }}</a> -->
            <a :href="user.have_shop ? MixinDomain.seller : '/shop/apply/'">{{ user.have_shop ? '我的店铺' : '' }}</a>
          </div>
        </li>
        <!--   <li>
          <div class="dt">
            <a href=''>格桑会员</a>
          </div>
        </li>
        <li class="spacer"></li>
        <li>
          <div class="dt">
            <a href=''>客服服务</a>
          </div>
        </li> -->
      </ul>

      <!-- <div v-if="user" class="login-status logined">
        <span>您好<router-link to="/member">{{ user.nickname || user.uname }}</router-link>，欢迎来到</span>
        <router-link to="/">{{ site.site_name }}</router-link>
        <span>[<a href="javascript:" @click="handleLogout">退出</a>]</span>
      </div>
      <div v-else class="login-status">
        <span>您好，欢迎来到</span>
        <router-link to="/" style="color: #333">{{ site.site_name }}</router-link>
        <span>[<router-link :to="'/login' + MixinForward">登录</router-link>] [<router-link :to="'/register' + MixinForward">注册</router-link>]</span>
      </div>
      <ul class="links">
        <li>
          <div class="dt">
            <a :href="user.have_shop ? MixinDomain.seller : '/shop/apply/'">{{ user.have_shop ? '我的店铺' : '商家入驻' }}</a>
          </div>
        </li>
        <li class="spacer"></li>
        <li class="dorpdown">
          <div class="dt hs-icon">
            <router-link to="/member/my-order">我的订单</router-link>
            <i class="iconfont ea-icon-arrow-down"></i>
          </div>
          <div class="dd dorpdown-layer">
            <dl>
              <dd>
                <router-link to="/member/my-order?order_status=WAIT_PAY">待付款订单</router-link>
              </dd>
              <dd>
                <router-link to="/member/my-order?order_status=WAIT_ROG">待收货订单</router-link>
              </dd>
              <dd>
                <router-link to="/member/my-order?order_status=WAIT_COMMENT">待评价订单</router-link>
              </dd>
            </dl>
          </div>
        </li>
        <li class="spacer"></li>
        <li class="dorpdown">
          <div class="dt hs-icon">
            <router-link to="/member/goods-collection">我的收藏</router-link>
            <i class="iconfont ea-icon-arrow-down"></i>
          </div>
          <div class="dd dorpdown-layer">
            <dl>
              <dd>
                <router-link to="/member/goods-collection">收藏的商品</router-link>
              </dd>
              <dd>
                <router-link to="/member/shop-collection?type=shop">收藏的店铺</router-link>
              </dd>
            </dl>
          </div>
        </li>
        <li class="spacer"></li>
        <li class="dorpdown">
          <div class="dt hs-icon">
            <a href="#">站点导航</a>
            <i class="iconfont ea-icon-arrow-down"></i>
          </div>
          <div class="dd dorpdown-layer">
            <dl>
              <dd><a href="/">商城首页</a></dd>
              <dd>
                <a :href="user.have_shop ? MixinDomain.seller : '/shop/apply/'">{{ user.have_shop ? '我的店铺' : '商家入驻' }}</a>
              </dd>
              <dd>
                <router-link to="/member">个人中心</router-link>
              </dd>
            </dl>
          </div>
        </li>
        <li class="spacer"></li>
        <li class="dorpdown">
          <div class="dt">
            <router-link to="/help">帮助中心</router-link>
          </div>
        </li>
        <li class="spacer"></li>
        <li class="dorpdown">
          <div v-if="im" class="dt hs-icon">
            <router-link to="">
              服务消息[{{ (unreadMessageNum + chat_unread_num) > 99 ? '99+' : (unreadMessageNum + chat_unread_num) }}]
            </router-link>
            <i class="iconfont ea-icon-arrow-down"></i>
          </div>
          <div v-else class="dt">
            <router-link to="/member/message-index">
              站内消息[{{ unreadMessageNum > 99 ? '99+' : unreadMessageNum }}]
            </router-link>
          </div>
          <div v-if="im" class="dd dorpdown-layer">
            <dl>
              <dd>
                <router-link to="/chat" target="_self">
                  客服消息({{ chat_unread_num > 99 ? '99+' : chat_unread_num }})
                </router-link>
              </dd>
              <dd>
                <router-link to="/member/message-index">
                  站内消息({{ unreadMessageNum > 99 ? '99+' : unreadMessageNum }})
                </router-link>
              </dd>
            </dl>
          </div>
        </li>
      </ul> -->
    </div>
  </div>
</template>

<script>
import Storage from '@/utils/storage';
import { mapActions, mapGetters } from 'vuex';
import * as API_Message from '@/api/message';

export default {
  name: 'EnShortcut',
  head() {
    return {
      meta: [
        { hid: 'keywords', name: 'keywords', content: this.site.keywords },
        { hid: 'description', name: 'description', content: this.site.descript },
      ],
    };
  },
  data() {
    return {
      message_total: 0,
      message_timer: null,
      chat_unread_num: 0,
      chat_timer: null,
      im: process.env.IM,
      isPublic: '1',
      // loginNow:false
    };
  },
  computed: {
    ...mapGetters(['user', 'site', 'unreadMessageNum']),
    loginNow() {
      // alert(localStorage.getItem("loginNow"))
      return localStorage.getItem('loginNow') == 1 ? true : false;
    },
    fromJRC() {
      return localStorage.getItem('from') && localStorage.getItem('from') == 'JRC' ? true : false;
    },
  },
  mounted() {
    // 如果是首页，并且有uuid，那么替换掉cookie中的uuid，并且移除url中的uuid
    const { name, query } = this.$route;
    if (name === 'index' && query.uuid) {
      Storage.setItem('uuid', query.uuid);
      Storage.removeItem('uuid_connect');
      location.href = '/';
      return;
    }
    this.isPublic = localStorage.getItem('isPublic');
    // 如果有刷新Token，重新获取用户信息【第一次访问和用户刷新页面，会触发】
    if (Storage.getItem('refresh_token') || localStorage.getItem('refresh_token')) {
      this.getUserData();
    } else {
      this.$store.dispatch('user/removeUserAction');
    }
    this.GET_UnreadMessage();
    this.GET_UnreadChatNum();
    console.log('this.user', this.user);
    // this.loginNow =  localStorage.getItem("loginNow") == 1?true : false
    // alert(localStorage.getItem("loginNow"))
    // alert(this.loginNow)
  },
  methods: {
    ...mapActions({
      logout: 'user/logoutAction',
      getUserData: 'user/getUserDataAction',
      cleanCartStore: 'cart/cleanCartStoreAction',
      getUnreadMessageNum: 'getUnreadMessageNumAction',
    }),
    showPhone() {
      this.$alert('客服电话：021-60653900', '客服电话', {
        confirmButtonText: '确定',
      });
    },
    /** 账户登出 */
    handleLogout() {
      this.logout().then(() => {
        this.cleanCartStore();
        document.location.reload();
      });
    },
    /** 获取未读消息 */
    async GET_UnreadMessage() {
      if (!Storage.getItem('refresh_token')) return;
      try {
        clearTimeout(this.message_timer);
        await this.getUnreadMessageNum();
      } finally {
        // 消息轮询，5分钟查一次
        this.message_timer = setTimeout(this.GET_UnreadMessage, 1000 * 60 * 5);
      }
    },
    /**
     * 获取未读客服消息数量
     * @returns {Promise<void>}
     */
    async GET_UnreadChatNum() {
      // if (!this.im || !Storage.getItem('refresh_token')) return
      // try {
      //   clearTimeout(this.chat_timer)
      //   this.chat_unread_num = await API_Message.getUnreadChatNum()
      // } finally {
      //   // 客服IM未读消息数量，1分钟查询一次
      //   this.chat_timer = setTimeout(this.GET_UnreadChatNum, 1000 * 60 * 1)
      // }
    },
  },
};
</script>

<style type="text/scss" lang="scss" scoped>
@import '../assets/styles/color';
#shortcut {
  border-bottom: 1px solid #fff;
  background-color: #fff;
  .w {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 51px;
    line-height: 30px;
    width: 1071px;
    margin: 0 auto;
  }
  .login-status {
    a {
      color: #666;
    }
  }
  .logined a {
    color: #333;
  }
  a:hover {
    color: $color-main;
  }
}
.links {
  z-index: 100;
  position: absolute;
  width: 260px;
  height: 30px;
  margin: 19px auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  a {
    font-size: 14px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
    font-weight: 400;
    text-align: left;
    color: #666666;
    line-height: 18px;
  }
  .ahover {
    color: #e76024;
  }
  li {
    position: relative;
    float: left;
    &.spacer {
      overflow: hidden;
      margin: 7px 2px 0;
      width: 1px;
      height: 15px;
      background-color: #ccc;
    }
    &.dorpdown:hover {
      .dorpdown-layer {
        display: block;
      }
      .dt {
        z-index: 3;
      }
      .iconfont {
        transform: rotate(180deg);
      }
    }
    .dt {
      padding-left: 7px;
      padding-right: 7px;
      &.hs-icon {
        height: 28px;
        line-height: 28px;
        overflow: hidden;
        position: relative;
        z-index: 1;
        float: left;
        padding-right: 20px;
      }
      .iconfont {
        position: absolute;
        right: 5px;
        top: 10px;
        width: 12px;
        height: 12px;
        line-height: 12px;
        font-size: 12px;
        transition: all 0.3s ease-out;
      }
    }
    .dorpdown-layer {
      background-color: #fff;
      display: none;
      width: auto;
      border: solid 1px #f0f0f0;
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      padding-top: 30px;
      dd {
        cursor: pointer;
        &:hover {
          background-color: #f5f6f5;
        }
      }
      a {
        line-height: 24px;
        padding-left: 7px;
      }
    }
  }
}
.links2 {
  position: inherit;
  width: auto;
  margin: 0px 0 0;
}
.zyz_dw {
  font-size: 14px;
  font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
  font-weight: 400;
  text-align: left;
  color: #666666;
  line-height: 18px;
  display: flex;
  align-items: center;
  .dw_t1 {
    width: 33px;
    height: 34px;
    margin-left: 11px;
  }
  .dw_t2 {
    width: 12px;
    height: 17px;
    // position: relative;
    // top: -10px;
  }
}

.el-dropdown-link {
    cursor: pointer;

    &:hover {
      color: red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Shortcut.vue